import { z } from 'zod';

import { IsoDateTimeSchema, UuidSchema } from '../dto/common.js';

/**
 * Every domain event travels in this envelope (plan Appendix D, ADR 0002). Consumers dedupe
 * on `eventId`, and `correlationId` carries the originating request id across services.
 */
export const EventEnvelopeSchema = z.object({
  eventId: UuidSchema,
  type: z.string().regex(/^[a-z]+\.[a-zA-Z]+\.[a-zA-Z]+$/),
  version: z.number().int().positive(),
  occurredAt: IsoDateTimeSchema,
  correlationId: z.string().min(1),
  payload: z.unknown(),
});
export type EventEnvelope<TType extends string = string, TPayload = unknown> = {
  eventId: string;
  type: TType;
  version: number;
  occurredAt: string;
  correlationId: string;
  payload: TPayload;
};
